module.exports = __webpack_public_path__ + "static/media/cloudfundis.206cab2b.jpeg";